import { LoaderFunctionArgs } from "react-router"
import { AxiosError } from "axios"
import { queryClient } from "@/api/client"
import { InventorySetup, ReceivableSetup } from "../../twc/types"
import { tryCatch } from "@/lib/utils/try-catch"
import { getInventorySetUpQueryOptions } from "../../twc/api/inventory"
import { getReceivableSetupQueryOptions } from "../../twc/api/receivable"
import { LoaderResponse } from "@/types"

type TWCConfig = {
  inventory: InventorySetup | null
  receivable: ReceivableSetup | null
}

export const provisionsLoader = async ({ params }: LoaderFunctionArgs) => {
  const twcConfig: TWCConfig = {
    inventory: null,
    receivable: null,
  }
  const { id: financialModelId } = params
  if (!financialModelId) {
    return twcConfig
  }
  const [inventorySetup, inventoryError] = await tryCatch(
    queryClient.ensureQueryData(getInventorySetUpQueryOptions(financialModelId))
  )
  if (inventoryError) {
    if (inventoryError instanceof AxiosError && inventoryError.status === 404) {
      twcConfig.inventory = null
    } else {
      throw inventoryError
    }
  } else {
    twcConfig.inventory = inventorySetup
  }
  const [receivableSetup, receivableError] = await tryCatch(
    queryClient.ensureQueryData(
      getReceivableSetupQueryOptions(financialModelId)
    )
  )
  if (receivableError) {
    if (
      receivableError instanceof AxiosError &&
      receivableError.status === 404
    ) {
      twcConfig.receivable = null
    } else {
      throw receivableError
    }
  } else {
    twcConfig.receivable = receivableSetup
  }
  return twcConfig
}

export type ProvisionLoaderResponse = LoaderResponse<typeof provisionsLoader>
